export const RES_SUCCESS = 200
export const FORM_SUCCESS_ROUTE = "/success"
export const ERROR_MESSAGE =
  "There was an error with your request. Please try again."
